<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
      <v-col cols="12" xs="12" class="pt-0" v-if="showTitle">
        <v-card flat>
          <v-card-title>
            Medien
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" class="py-0" v-if="!this.isCompanyView">
        <v-checkbox outlined v-model="showAll" class="mx-2" label="Alle anzeigen" @change="onChangeAll"></v-checkbox>
      </v-col>
      <v-col cols="12" md="12">
        <v-row justify="end">
          <v-col cols="4" xs="4" class="pl-4">
            &nbsp;
          </v-col>
          <v-col cols="8" xs="8" md="3">
            <v-text-field
            v-model="search"
            append-icon="search"
            label="Suche"
            single-line
            clearable
            hide-details
            ></v-text-field>
          </v-col>

        </v-row>
      </v-col>
      <v-col cols="12" xs="12" v-if="completeData" align="start">
        Standorte: {{completeData.cntCompanies}}
        Geräte: {{completeData.cntDevices}}
        Medien: {{completeData.cntMedia}}
        Ausgewählte Einträge: {{selected.length}}
      </v-col>
      <v-col cols="12" xs="12" v-if="completeData && selected.length > 0" align="start">
        <v-btn small @click="setAllSelected(selected, false)">
          Alle aus
        </v-btn>
        <v-btn small @click="setAllSelected(selected, true)">
          Alle an
        </v-btn>
        &nbsp;
          <span v-if="cntChanged > 0" style="color:green; ">Verändert {{cntChanged}}</span>
      </v-col>
      <v-col cols="12" xs="12">

        <v-data-table
        :headers="headers"
        :items="mediaList"
        :search="search"
        v-model="selected"
        show-select
        hide-default-footer
        hide-details
        :items-per-page="-1"
        >
          <template v-slot:item.name="{ item }">
            <v-img :src="tableUtils.getImage(item)" :lazy-src="tableUtils.getImageThumbUrl(item)" contain alt="Thumbnail" max-height="80" max-width="80"></v-img>
            <span v-if="item.type !== 'WEB'" @click="editItem(item)" class="handpointer"> {{item.name}}</span>
            <span v-if="item.type === 'WEB'" @click="editItem(item)" class="handpointer"> {{item.localFileName}}</span>
          </template>

          <template v-slot:item.active="{ item }">
            <span> &asymp; {{item.active}}</span>
          </template>
          <template v-slot:item.playListName="{ item }">
            <span> {{item.playListName}}</span>
          </template>

          <template v-slot:item.action="{ item }">
            <v-row>
              <v-col>
            <v-btn small @click="setAll(item, true)">
              Alle an
            </v-btn>
              </v-col>
              <v-col>
            <v-btn small @click="setAll(item, false)">
              Alle aus
            </v-btn>
              </v-col>
            </v-row>
            <!--
            <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
            >
              edit
            </v-icon>
            <v-icon
                    small
                    @click="deleteItem(item)"
            >
              delete
            </v-icon>

            -->
          </template>
        </v-data-table>
      </v-col>

      <DialogLinkCompany ref="dlgLink" @save="onLinkCompany"></DialogLinkCompany>
      <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
      <v-dialog v-model="dialog">
        <v-card>
          <v-card-title class="headline">Aktiv Status setzen</v-card-title>
          <v-card-text>Das setzen des Status betrifft <span class="cntOver">{{cntItems}}</span> Media Items / Items</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="darken" @click="dialog = false">abbrechen</v-btn>
            <v-btn color="darken" @click="setStatusNow()">Status jetzt setzen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</template>

<script>
import Vue from 'vue'
import DialogLinkCompany from './../module/dialogs/DialogLinkCompany'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

var _ = require('lodash')
export default {
  name: 'TableMedien',
  props: {
    companyId: String,
    showTitle: Boolean,
    isCompanyView: Boolean
  },
  components: {DialogLinkCompany,DialogDeleteItem},
  methods: {
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Medium',
        id: '' + item.guid,
        name: 'Medium ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item)
      // Vue.prototype.$api.deleteDevice(item.item.guid, this.reload)
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.deviceGuid, item, this.reload)
    },
    onChangeAll: function () {
      Vue.prototype.storage.saveState('deviceShowAll', this.showAll)
      this.reload()
    },
    editItem: function (item) {
      if (this.companyId) {
        this.$router.push('/Netzwerke/' + this.companyId + '/Geraete/' + item.guid)
      } else {
        this.$router.push('/Geraete/' + item.guid)
      }

    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      if (this.companyId != null) {
        Vue.prototype.$api.loadMediaFromCompany(this.companyId, this.onGetData)
      } else {
        // Vue.prototype.$api.loadDevices(null, this.onGetData)
        this.onGetData([])
      }

    },
    reFilter: function () {
      let list = []
      for (var ii in this.completeData) {
        let item = this.completeData[ii]
        let found = false
        for (var index in item.tagArray) {
          let tag = item.tagArray[index]
          console.log('list', tag, this.filterTags)
          let fIndex = _.findIndex(this.filterTags, function (o) {
            return o === tag
          })
          if (fIndex > -1) {
            found = true
            break
          }
        }
        if (found) {
          list.push(item)
        }
      }
      console.log('list', list)
      this.mediaList = list
    },
    onGetData: function (result) {
      console.log('results', result)
      if (this.showAll) {
        this.mediaList = result.media
      } else {
        this.mediaList = result.media
      }
      let i = 0
      _.forEach(this.mediaList, function (media) {
        media.id = i
        i++;
      })
      this.completeData = _.clone(result)
    },
    onGetStatusList: function (data) {
      this.cntItems = data.cntMedia
      this.dialog = true
    },
    onGetStatusSet: function (data) {
      console.log('data', data)
      this.dialog = false
      this.reload()
    },
    setAll: function (item, state) {
      this.currentItem = item
      this.currentState = state
      Vue.prototype.$api.checkMediaStateFromCompany(this.companyId, item, state, this.onGetStatusList)
    },
    setAllSelected: function (arr, state) {
      let that = this
      this.currentState = state
      that.cntChanged = 0
      that.shouldChanged = arr.length
      let fnCheck = function (data) {
          console.log('data', data)
          that.cntChanged += 1
          if (that.cntChanged >= that.shouldChanged) {
              that.dialog = false
              that.reload()
          }
      }
      _.each(arr, function (item) {
        Vue.prototype.$api.setMediaStateFromCompany(that.companyId, item, that.currentState, fnCheck)
      })
    },
    setStatusNow: function () {
      Vue.prototype.$api.setMediaStateFromCompany(this.companyId, this.currentItem, this.currentState, this.onGetStatusSet)
    }
  },
  data () {
    return {

      currentDevice: null,
      search: null,
      showAll: false,
      dialog: false,
      cntChanged: 0,
      cntItems: 0,
      hdSizeUsed: 0,
      selected: [],
      tags: [],
      filterTags: [],
      tableUtils: require('./TableUtils').default,
      headers: [
      ],
      mediaList: []
    }
  },
  mounted () {
    if (this.isCompanyView) {
      this.showAll = true
    } else {
      this.showAll = Vue.prototype.storage.getState('deviceShowAll')
    }
    if (this.showAll) {
       this.headers = [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Playlist', align: 'left', value: 'playListName'},
        {text: 'Erstellt', value: 'created'},
         {text: 'Aktiv', value: 'active'},
        {text: 'Aktion', value: 'action'}
      ]
    }

    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
  }
}
</script>

<style scoped>

  .cntOver {
    font-weight: bolder;
    font-size: 2em;
  }

</style>

<!--
        {text: 'Status', value: 'deviceState'},
        {text: 'Name', align: 'left', value: 'name'},
        /* {text: 'Android Id', align: 'left', value: 'androidId'}, */
        {text: 'Playlist', align: 'left', value: 'playlistName'},
        /*{text: 'Screen', value: 'screenNumber'},*/
        {text: 'Client Version', value: 'clientVersionString'},
        {text: 'Tags', value: 'tags'},
        {text: 'HD Kapazität', value: 'diskUsageCurrent'},
        /*{text: 'Erstellt', value: 'created'},*/
        {text: 'Letzte Rückmeldung', value: 'heartbeatDateTime'},
        /*{text: 'Remote', value: 'remoteAddress'},*/
        /*{text: 'Netzwerk', value: 'company'},*/
        {text: 'Kommentar', value: 'comment'},
        {text: 'Aktion', value: 'action'}

-->
